export default "__VITE_ASSET__4b9982d4__"